import { ICart } from "redux/reducers/models/cart";

export function isAutoDiscountsDisabled(cart: ICart | undefined): boolean {
  return cart?.disable_auto_discounts === true || cart?.disable_auto_discounts === 1;
}

export function showDisableDiscountsOption(cart: ICart | undefined): boolean {
  const hasLineItemDiscount = (cart?.discount_lines ?? []).some(
    d => d.application === "line_item" && d.cart_line_item_id != null,
  );

  return hasLineItemDiscount || isAutoDiscountsDisabled(cart);
}

export function nextDisableAutoDiscountsValue(cart: ICart | undefined): boolean {
  return !isAutoDiscountsDisabled(cart);
}
